<template src="./NotFound.html"></template>
<style lang="scss" scoped src="./NotFound.scss"></style>

<script>
import {
  SfBreadcrumbs,
  SfButton,
  SfHeading
} from '@storefront-ui/vue';

export default {
  name: "NotFound",
  components: {
    SfHeading,
    SfButton,
    SfBreadcrumbs
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$i18n.t('Home'),
          link: '/'
        },
        {
          text: '404',
        }
      ]
    };
  },
  mounted() {
    window.onpopstate = function (event) {
      history.go(-2);
    }
  },
}
</script>
